module.exports = __webpack_public_path__ + "esTEAM_logo_path.svg";